import _ from 'lodash'
import * as yup from 'yup'

export const flightNoRegex = /^\w{1,4}$/

export const checkFlightNoIsValid = (value: any): boolean =>
    // check
    /^[0-9a-zA-Z]{2}[0-9a-zA-Z]{3,6}$/.test(value) || flightNoRegex.test(value)

export const viewFlightStatusFormValidations = yup.object().shape({
    carrier: yup.string().notOneOf(['-Select-'], 'Carrier is required').required('Carrier is required'),
    flightDate: yup.string().required('Flight Date is required'),
    flightNo: yup
        .string()
        .test('flightNo-validation', 'Flight No. is Invalid', checkFlightNoIsValid)
        .required('Flight No is required.')
})

const formatTime = (time: string): string => {
    if (time !== '-' && time.trim().length === 4) {
        return time.slice(0, 2) + ':' + time.slice(2)
    }
    return '-'
}

const formatStatus = (status: string): string => {
    if (status === 'Cancel') {
        return 'Cancelled'
    } else if (status === 'Schedule') {
        return 'Scheduled'
    } else if (status.toLowerCase() === 'on time') {
        return 'On Time'
    } else {
        return status.toUpperCase().slice(0, 1) + status.toLowerCase().slice(1)
    }
}

const formatDate = (date: string): string => {
    const month = date.substring(2, 5)
    return month.toUpperCase().slice(0, 1) + month.toLowerCase().slice(1) + ' ' + date.substring(0, 2)
}

export const formatResponse = (response: any) => {
    const data: object[] = []
    response.LEG?.forEach((leg) => {
        const tempObject = {
            flight: '',
            departureDate: '',
            departure: '',
            departTime: '',
            departNewTime: '',
            arrival: '',
            arrivalDate: '',
            arrivalTime: '',
            arrivalNewTime: '',
            aircraft: '',
            status: '',
            scheduledDepartureDate: '',
            scheduledArrivalDate: ''
        }
        tempObject.flight = _.get(response, 'FLIGHT', '-')
        tempObject.departure = _.get(leg, 'ORIGIN.STATION', '-')
        tempObject.arrival = _.get(leg, 'DEST.STATION', '-')
        tempObject.aircraft = _.get(leg, 'EQUIP.CODE', '-')
        tempObject.status = formatStatus(_.get(leg, 'DEST.STATUS', '-'))
        if (_.get(leg, 'DEST.STATUS', '-') === 'Late' || _.get(leg, 'DEST.STATUS', '-') === 'Early') {
            tempObject.departTime = formatTime(_.get(leg, 'ORIGIN.OUTTIME.TIME', '-'))
            tempObject.arrivalTime = formatTime(_.get(leg, 'DEST.ONTIME.TIME', '-'))
            tempObject.departNewTime = formatTime(_.get(leg, 'ORIGIN.SCHED.TIME', '-'))
            tempObject.arrivalNewTime = formatTime(_.get(leg, 'DEST.SCHED.TIME', '-'))
            tempObject.departureDate = formatDate(_.get(leg, 'ORIGIN.OUTTIME.DATE', '-'))
            tempObject.arrivalDate = formatDate(_.get(leg, 'DEST.ONTIME.DATE', '-'))
            tempObject.scheduledDepartureDate = formatDate(_.get(leg, 'ORIGIN.SCHED.DATE', '-'))
            tempObject.scheduledArrivalDate = formatDate(_.get(leg, 'DEST.SCHED.DATE', '-'))
        } else {
            tempObject.departTime = formatTime(_.get(leg, 'ORIGIN.SCHED.TIME', '-'))
            tempObject.arrivalTime = formatTime(_.get(leg, 'DEST.SCHED.TIME', '-'))
            tempObject.departureDate = formatDate(_.get(leg, 'ORIGIN.SCHED.DATE', '-'))
            tempObject.arrivalDate = formatDate(_.get(leg, 'DEST.SCHED.DATE', '-'))
        }
        data.push(tempObject)
    })
    return data
}

export const formatFlightNumber = (carrier: string, flightNo: string) => {
    const formattedCarrier = carrier.slice(-4).substring(1, 3)

    if (!flightNo.includes(formattedCarrier) && /^\d+$/.test(flightNo)) {
        const numericPart = flightNo.replace(/\D/g, '')
        const leadingZeros = '0'.repeat(Math.max(0, 3 - numericPart.length))
        return `${formattedCarrier}${leadingZeros}${numericPart}`
    } else if (flightNo.length === 4 && !flightNo.includes(formattedCarrier)) {
        return `${formattedCarrier}${flightNo}`
    } else {
        let carrierIndex
        if (flightNo.length <= 3) {
            carrierIndex = flightNo.indexOf(formattedCarrier) + formattedCarrier.length
        } else if (flightNo.length === 4) {
            carrierIndex = flightNo.indexOf(formattedCarrier) + formattedCarrier.length
        } else {
            carrierIndex = flightNo.indexOf(formattedCarrier) + formattedCarrier.length - 1
        }
        const flightString = flightNo.substring(carrierIndex)

        const leadingZeros = flightString.length < 3 ? '0'.repeat(Math.max(0, 3 - flightString.length)) : flightString
        const formattedResult =
            flightString.length < 3
                ? `${formattedCarrier}${leadingZeros}${flightString}`
                : `${formattedCarrier}${leadingZeros}`
        return formattedResult
    }
}
